/*
 *
 * (object) proxy
 *
 */
export default function proxy (schema) {
  const descriptor = {}

  Object.keys(schema).map(k => {
    const cache = '_$' + k
    descriptor[k] = {
      get () {
        if (Object.prototype.hasOwnProperty.call(this, cache)) return this[cache]
        this[cache] = schema[k].apply(this)
        return this[cache]
      },
    }
  })

  return function (root) {
    return function (o) {
      Object.defineProperties(o, descriptor)
      o.$root = root
      return o
    }
  }
}
